module.exports = __webpack_public_path__ + "static/st-3-317424bf493e0757521aed8022c1c74d.jpg";